import { Link } from 'react-router-dom'

export default function Cancel() {
  return (
    <div className="max-w-2xl mx-auto text-center py-12">
      <div className="card">
        <div className="w-20 h-20 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg
            className="w-10 h-10 text-yellow-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
        </div>

        <h1 className="text-3xl font-bold text-gray-800 mb-4">
          Payment Cancelled
        </h1>

        <p className="text-gray-600 mb-6">
          Your payment was cancelled. No charges have been made to your account.
        </p>

        <p className="text-gray-600 mb-8">
          If you experienced any issues or have questions, please don't hesitate
          to contact us at{' '}
          <a
            href="mailto:secretary@schoollunchangels.org"
            className="text-sla-blue hover:underline"
          >
            secretary@schoollunchangels.org
          </a>
        </p>

        <div className="space-x-4">
          <Link to="/" className="btn btn-primary">
            Back to Events
          </Link>
        </div>
      </div>
    </div>
  )
}
